module.exports = __webpack_public_path__ + "img/newspic01.6e883999.jpg";